module.exports = __webpack_public_path__ + "static/img/log_gray.305d327.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/log_gray.svg
// module id = Lvxn
// module chunks = 1